import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';

export class NomenclatureQuizScoresComponent {
    constructor() {
        this.componentName = "nomenclatureQuizScoresComponent";
        this.template = `
            <a href="javascript:void(0)" onClick="_cmp.nomenclatureQuiz.render()"><h3>Nomenclature Quiz</h3></a>
            <h3>Scores</h3>
            <h4 id="monthYear">{MonthYear}</h4>
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Score</th>
          <th scope="col">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-default">
          <td scope="row">10</td>
          <td id="s10">10</td>
        </tr>
        <tr class="table-default">
          <td scope="row">9</td>
          <td id="s9">9</td>
        </tr>
        <tr class="table-default">
          <td scope="row">8</td>
          <td id="s8">8</td>
        </tr>
        <tr class="table-default">
          <td scope="row">7</td>
          <td id="s7">7</td>
        </tr>
        <tr class="table-default">
          <td scope="row">6</td>
          <td id="s6">6</td>
        </tr>
        <tr class="table-default">
          <td scope="row">5</td>
          <td id="s5">5</td>
        </tr>
        <tr class="table-default">
          <td scope="row">4</td>
          <td id="s4">4</td>
        </tr>
        <tr class="table-default">
          <td scope="row">3</td>
          <td id="s3">3</td>
        </tr>
        <tr class="table-default">
          <td scope="row">2</td>
          <td id="s2">2</td>
        </tr>
        <tr class="table-default">
          <td scope="row">1</td>
          <td id="s1">1</td>
        </tr>
        <tr class="table-default">
          <td scope="row">0</td>
          <td id="s0">0</td>
        </tr>
        
      </tbody>
    </table>
        `;
    }
	
    render(yearMonth, monthYear){
        _cmp.main.hideAll();
        _svc.util.showLoader("#" + this.componentName);
        var el = _svc.util.element(this.componentName);
        el.setAttribute("data-yearMonth", yearMonth);
        el.setAttribute("data-monthYear", monthYear);
        _svc.data.getQuizScores("NomenclatureQuiz", yearMonth, monthYear, _cmp.nomenclatureQuizScores.postBackSuccess, _cmp.nomenclatureQuizScores.postBackFailed);
    }
    
    postBackSuccess(data) {
        _svc.util.html("#" + _cmp.nomenclatureQuizScores.componentName, _cmp.nomenclatureQuizScores.template);
        _svc.util.html("#s0", data.s0);
        _svc.util.html("#s1", data.s1);
        _svc.util.html("#s2", data.s2);
        _svc.util.html("#s3", data.s3);
        _svc.util.html("#s4", data.s4);
        _svc.util.html("#s5", data.s5);
        _svc.util.html("#s6", data.s6);
        _svc.util.html("#s7", data.s7);
        _svc.util.html("#s8", data.s8);
        _svc.util.html("#s9", data.s9);
        _svc.util.html("#s10", data.s10);
        var el = _svc.util.element(_cmp.nomenclatureQuizScores.componentName);
        _svc.util.html("#monthYear", el.getAttribute("data-monthYear"));
		
	}
	
	postBackFailed() {
		_svc.util.clear("#" + _cmp.nomenclatureQuizScores.componentName);
	}
};

setTimeout(() => {
    _cmp.nomenclatureQuizScores = new NomenclatureQuizScoresComponent();    
}, 1);
